import { render, staticRenderFns } from "./CustomerModel.vue?vue&type=template&id=2fa2818f&scoped=true&"
import script from "./CustomerModel.vue?vue&type=script&lang=js&"
export * from "./CustomerModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2818f",
  null
  
)

export default component.exports